// src/data/attestationData.js
const attestationData = [
    {
      id: "sla",
      title: "Singapore Academy of Law (SLA)",
      shortDescription: "Authenticate documents through the Singapore Academy of Law quickly and securely.",
      image: "/attestation/sla.webp",
      details: `The Singapore Academy of Law (SLA) attestation is essential for legalizing documents used in Singapore. 
      Our service ensures that each document is authenticated according to Singapore's legal requirements, 
      saving you time and ensuring accuracy. We'll guide you through the entire process, from initial document checks 
      to final certification.`
    },
    {
      id: "notary",
      title: "Notary",
      shortDescription: "Professional notary services to validate and certify your important documents.",
      image: "/attestation/notary.webp",
      details: `Notarization is a vital step in verifying the authenticity of signatures and documents for international or 
      domestic use. Our experienced notaries provide comprehensive services that include verifying identities, 
      witnessing signatures, and applying the official notary seal. We ensure a seamless process with minimal 
      paperwork and swift turnaround times.`
    },
    {
      id: "india",
      title: "India Issued Certificates (MEA Apostile, HRD)",
      shortDescription: "Authenticate India-issued certificates with MEA Apostille and HRD attestation.",
      image: "/attestation/india.webp",
      details: `For India-issued certificates—such as birth certificates, educational documents, or marriage certificates—
      MEA Apostille and HRD attestation are often required for legal validity abroad. Our team handles all steps, 
      from initial state HRD verification to final MEA Apostille, ensuring your documents are accepted internationally.`
    },
    {
      id: "uae",
      title: "UAE Attestation",
      shortDescription: "Secure and official UAE attestation services for documents of all types.",
      image: "/attestation/uae.webp",
      details: `UAE attestation is crucial for individuals and businesses looking to use foreign documents in the UAE. 
      Whether for employment, education, or legal matters, our attestation experts manage the entire process, 
      including notarization, MOFA (Ministry of Foreign Affairs) stamps, and embassy attestation, so you can 
      confidently use your documents in the UAE.`
    },
    {
      id: "hci",
      title: "HCI Attestation",
      shortDescription: "Handle your High Commission of India (HCI) attestation needs with ease.",
      image: "/attestation/hci.jpg",
      details: `HCI attestation is often required for documents used in India or recognized by Indian authorities abroad. 
      Our service covers verifying the authenticity of certificates, obtaining the HCI stamp, and completing all 
      necessary paperwork. We streamline the entire procedure, ensuring compliance with Indian and international 
      regulations.`
    }
  ];
  
  export default attestationData;
  